import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";
import { useState } from "react";

interface LikeButtonProps {
  trackEventId: number;
  isLiked: boolean;
  likesCount: number;
  className?: string;
}

export default function LikeButton({
  trackEventId,
  isLiked: initialIsLiked,
  likesCount: initialLikesCount,
  className = "",
}: LikeButtonProps) {
  const [isLiked, setIsLiked] = useState(initialIsLiked);
  const [likesCount, setLikesCount] = useState(initialLikesCount);
  const [isLoading, setIsLoading] = useState(false);

  const handleLike = async () => {
    if (isLoading) return;

    setIsLoading(true);

    try {
      const url = `/event/${trackEventId}/like`;
      const response = await fetch(url, {
        method: isLiked ? "DELETE" : "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token":
            document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')
              ?.content || "",
        },
      });

      const data = await response.json();

      if (data.success) {
        setIsLiked(data.liked);
        setLikesCount(data.likes_count);
      } else {
        console.error("Failed to update like:", data.error);
      }
    } catch (error) {
      console.error("Error updating like:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      onClick={handleLike}
      disabled={isLoading}
      variant="ghost"
      size="sm"
      className={`flex items-center gap-1.5 transition-all duration-300 hover:bg-transparent hover:text-current ${className} cursor-pointer`}
    >
      <Heart
        className={`h-5 w-5 transition-all duration-300 ${
          isLiked ? "fill-red-500 text-red-500 scale-110" : "hover:scale-110"
        }`}
      />
      <span
        className="text-sm font-medium transition-all duration-300 ease-out overflow-hidden"
        style={{
          width: likesCount > 0 ? "auto" : "0",
          opacity: likesCount > 0 ? 1 : 0,
        }}
      >
        {likesCount > 0 && likesCount}
      </span>
    </Button>
  );
}
